/** Edit one role. */

import { useParams } from "react-router-dom";

import { Crumbs, PageHead, Problem } from "@/components/kit";
import { RoleForm } from "@/components/RoleForm";
import { ApiError, getRole, listDefinitions } from "@/lib/api/client";
import { useApi } from "@/spa/useApi";
import { publishedSports } from "@/spa/pages/NewRolePage";

export function EditRolePage() {
  const { id = "" } = useParams<{ id: string }>();

  const { data, loading, error, cause } = useApi(
    async () => {
      const initial = await getRole(id);
      const sports = publishedSports(await listDefinitions());
      return { initial, sports };
    },
    [id],
    "failed to load",
  );

  if (error) {
    if (cause instanceof ApiError && cause.status === 404) {
      return <Problem>Role not found.</Problem>;
    }
    return <Problem>Could not load role: {error}</Problem>;
  }
  if (!data) return <PageHead title="Role" note={loading ? "Loading…" : ""} />;

  return (
    <>
      <Crumbs trail={[{ label: "Roles", href: "/roles" }, { label: data.initial.name }]} />
      <RoleForm sports={data.sports} initial={data.initial} />
    </>
  );
}
